import React from 'react'
import comm_imgs from '../../../../comm_imgs';
export const RR =(props)=>{
    return(
        <svg viewBox='0 0 60 60' className={`upperPic ${props.type} lung`}
            style={{"shapeRendering":"geometricPrecision",
            "textRendering":"geometricPrecision", 
            "imageRendering":"optimizeQuality", 
            "fillRule":"evenodd", 
            "clipRule":"evenodd"}}>
            <path className="fil0" d="M36 22c7,4 9,3 17,3l0 3 -6 0c0,2 5,9 6,12l-3 1 -4 -7 0 5 -3 0 0 -10c-2,-1 -2,-1 -3,-2 -2,0 -3,-1 -4,-1l0 -4zm24 8l0 9c0,7 0,14 0,21 -7,0 -12,-2 -15,-7 -4,-6 -10,-5 -10,-13 0,-4 0,-9 0,-14 -2,-1 -4,-3 -4,-5l-1 0c-1,2 -3,4 -5,5 0,7 1,16 -2,20 -2,3 -5,2 -8,7 -1,2 -1,2 -4,4 -3,3 -5,3 -11,3 0,-7 0,-14 0,-21l0 -10c0,-3 1,-6 3,-9 2,-4 6,-7 12,-9 11,-3 10,5 10,10 2,-2 3,-5 3,-9 0,-4 0,-8 0,-12l4 0c0,7 -1,18 3,21 0,-4 0,-7 2,-9 4,-3 11,0 16,3 6,4 7,9 7,15zm-43 -1l0 10 -3 0 0 -5 -4 7 -2 -1c0,-3 5,-10 5,-12l-6 0 0 -3c8,0 10,1 17,-3l0 4 -7 3z"/>
        </svg>
    );	

}

export const HR =(props)=>{
    return(
        <svg viewBox="0 0 60 52" className={`upperPic ${props.type} heart`}>
            <g id="圖層_x0020_1">
                <metadata id="CorelCorpID_0Corel-Layer"/>
                <g id="_2288855659408">
                    <path d="M0 16c0,3 0,5 1,7 0,1 0,1 0,1l14 0 3 -5c0,-2 2,-2 2,-1 1,0 3,4 3,5 1,1 3,6 3,6 2,-1 2,-5 4,-5 2,0 3,4 4,5 0,-1 1,-2 1,-3 1,-1 4,-8 5,-8 0,-1 2,-1 2,0l3 6 14 0 1 -3c0,-1 0,-2 0,-3l0 -2c0,-4 -2,-8 -4,-11 -2,-2 -3,-2 -5,-3 -4,-3 -10,-3 -14,0l-3 2c-1,1 -2,3 -3,4 -1,1 -1,1 -1,1 0,0 -2,-3 -3,-4 0,0 0,0 -1,0 -2,-3 -6,-5 -9,-5 -3,0 -5,0 -8,2 -1,0 -1,0 -1,0 -1,0 -1,0 -1,1l-1 1c-2,1 -4,4 -5,6 0,1 -1,4 -1,6z"/>
                    <path d="M3 28l2 2c1,2 5,6 6,7l6 5c1,0 1,0 1,1 0,0 0,0 0,0l1 1c0,0 0,0 1,0l7 6c0,0 0,0 0,0 0,1 2,2 3,2 1,0 1,0 1,0 3,-2 6,-5 9,-7l9 -8c0,0 0,0 0,-1 1,0 3,-2 4,-3 0,0 0,-1 0,-1 1,0 3,-2 3,-3 0,-1 1,-1 1,-1l-13 0c-1,-1 -2,-2 -2,-3 -1,-1 -1,-2 -1,-2 -1,0 -1,1 -1,1 0,1 -1,1 -1,2 -1,1 -1,2 -2,3l-2 5c-1,1 -2,1 -3,0l-2 -4c0,1 -1,2 -1,3 -1,1 -1,2 -3,2 -1,0 -1,-2 -2,-3l-3 -6c0,-1 -1,-3 -2,-3 0,0 0,1 0,2 -2,3 -2,3 -5,3 -4,0 -7,0 -11,0z"/>
                </g>
            </g>
        </svg>
    );	

}

export const WS =(props)=>{
    return(
        <div className='upperPic icon_pic ws fx-ccc'>
            <img src={comm_imgs.WEIGHT_SCALE} className='ws' alt='weight scale'/>
        </div>
    );	

}